module.exports = __webpack_public_path__ + "img/RBatteringRam64_ua.4c30617a.webp";